var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#FFFFFF"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56FE\u6807/\u7F3A\u7701\u9875/\u65E0\u65B0\u6D88\u606F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39CF8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEDCC7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7FFDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FFF5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 31.2958691,
    height: 24.7863248
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64CCA0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F9EA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4F1D0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u7F3A\\u7701\\u9875/\\u65E0\\u65B0\\u6D88\\u606F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(1.749689, 2.111796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-1)",
    x: 40.2503109,
    y: 40.8882043,
    width: 7,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#BDF4DB",
    x: 37.2503109,
    y: 40.8882043,
    width: 3,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.342956,41.3497428 L23.342956,7.88820433 L54.331249,7.88820433 L54.3314456,7.90513183 C60.8908726,8.245362 66.1047532,13.6716936 66.1047532,20.3157922 L66.1047532,41.3497428 L23.342956,41.3497428 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#93F3C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(10.335522, 7.888204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,0 C20.1996028,-1.32019049e-15 26.025641,5.82603819 26.025641,13.0128205 L26.025641,33.4615385 L26.025641,33.4615385 L0,33.4615385 L0,13.0128205 C8.96229843e-16,5.82603819 5.82603819,1.32019049e-15 13.0128205,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,2.47863248 C18.8306919,2.47863248 23.5470085,7.19494911 23.5470085,13.0128205 L23.5470085,33.4615385 L23.5470085,33.4615385 L2.47863248,33.4615385 L2.47863248,13.0128205 C2.47863248,7.19494911 7.19494911,2.47863248 13.0128205,2.47863248 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#59C895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,2.47863248 C13.605333,2.47863248 14.18642,2.52755059 14.7522632,2.62156843 C9.7618472,3.45071041 5.95726496,7.78746156 5.95726496,13.0128205 L5.95726496,13.0128205 L5.95726496,33.4615385 L2.47863248,33.4615385 L2.47863248,13.0128205 C2.47863248,7.19494911 7.19494911,2.47863248 13.0128205,2.47863248 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#4EB586",
    opacity: 0.300000012
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2.586662, 32.922793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)",
    id: "\\u7F16\\u7EC4-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.424296, 0.569464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.534485, 11.642777) rotate(7.000000) translate(-20.534485, -11.642777) translate(0.991447, 2.312148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8521997,2.89843402 L39.0860756,0.0456727666 L29.1836278,10.7306947 C24.4974408,15.7872234 17.9154156,18.6612587 11.0213,18.6612587 C8.53446702,18.6612587 6.51849056,16.6452822 6.51849056,14.1584492 C6.51849056,12.970157 6.98820789,11.8300379 7.82525891,10.9866021 L15.8521997,2.89843402 L15.8521997,2.89843402 Z",
    id: "\\u8DEF\\u5F84-7\\u5907\\u4EFD",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9620271,2.64742794 L36.5235974,-1.38701225e-13 L27.9130365,9.24186998 C23.3850322,14.1018586 17.0511516,16.8763974 10.4087716,16.9095648 C8.11844476,16.921001 6.25249707,15.0735952 6.24106079,12.7832684 C6.23537403,11.644388 6.69831195,10.5532908 7.52125323,9.76598624 L14.9620271,2.64742794 L14.9620271,2.64742794 Z",
    id: "\\u8DEF\\u5F84-7",
    fill: "url(#linearGradient-6)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(17.085212, 23.770996)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.61544783,
    y1: 13.4847005,
    x2: 7.41722985,
    y2: 15.4847005,
    id: "\\u8DEF\\u5F84-19",
    stroke: "#E3A041",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.6154478,
    y1: 13.4847005,
    x2: 10.4172298,
    y2: 15.4847005,
    id: "\\u8DEF\\u5F84-19\\u5907\\u4EFD",
    stroke: "#E3A041",
    strokeLinecap: "round",
    transform: "translate(11.016339, 14.484701) scale(-1, 1) translate(-11.016339, -14.484701) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11156579,0 C9.41609053,0 11.603916,1.58528646 12.1931088,5.578125 C12.7823015,9.57096354 14.7077572,10.6137695 18.3675879,9.02571615 C18.1816613,9.55897352 18.0369401,9.92190213 17.9334245,10.114502 L19.3209571,9.98461914 C16.0639584,13.444153 12.384298,14.6924169 8.28197594,13.7294108 C2.12849287,12.2849017 2.17546603,8.60538737 2.17546603,6.72900391 C2.17546603,4.85262044 2.47863248,0 7.11156579,0 Z",
    id: "\\u8DEF\\u5F84-8",
    fill: "#FBD283"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-18",
    fill: "#FFEDCB",
    points: "3.46211703 3.47900391 3.36132821 6.00552529 -1.68449327e-16 4.46923828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91478844,2.72900391 C4.91478844,3.55743103 5.58636132,4.22900391 6.41478844,4.22900391 C7.24321557,4.22900391 7.91478844,3.55743103 7.91478844,2.72900391",
    id: "\\u8DEF\\u5F84",
    stroke: "#CE9543",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01633884,7.46468099 L13.2540742,10.927936 C11.0942279,11.489387 9.68164949,11.489387 9.01633884,10.927936 C8.35102819,10.366485 8.35102819,9.21206664 9.01633884,7.46468099 Z",
    id: "\\u8DEF\\u5F84-20",
    fill: "#E3A041",
    opacity: 0.400000006
  }))), /*#__PURE__*/React.createElement("g", {
    id: "love-song",
    transform: "translate(2.000000, 6.000000)",
    fill: "#FBD283",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81710463,1.42229037 L5.13810463,0.530290373 C4.83346649,0.428825032 4.49863502,0.479815328 4.2380096,0.66736265 C3.97738418,0.854909972 3.82266932,1.15619959 3.82210463,1.47729037 L3.82210463,6.59029037 C2.78627592,6.37885274 1.72942404,6.84182303 1.1825627,7.74658248 C0.635701362,8.65134194 0.717063129,9.80227965 1.3857679,10.6211086 C2.05447267,11.4399376 3.16594507,11.7496254 4.16172739,11.3945696 C5.15750972,11.0395139 5.82231173,10.0964786 5.82210463,9.03929037 C5.82210463,9.01629037 5.81610463,8.99529037 5.81510463,8.97229037 L5.81710463,8.97729037 L5.81110463,2.86329037 L7.81710463,3.53129037 L7.81710463,1.42229037 Z",
    id: "\\u8DEF\\u5F84",
    transform: "translate(4.319598, 6.009478) rotate(9.000000) translate(-4.319598, -6.009478) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDefault);
export default __webpack_public_path__ + "static/media/message_default.a52150c97b9e0171c9b1f569e4452602.svg";
export { ForwardRef as ReactComponent };